function NewQuestionTexts(languageCode) {
    return {        
        languageCode: languageCode
      }
}
export default NewQuestionTexts;
